<template>
  <div class="container-dfe">
    <div class="dfe">
      <div class="header-card">
        <div class="header-title-block">
          <div class="contentIconHeader">
            <b-icon-file-earmark-text
              style="width: 22px; height: 22px; color: #006256"
            />
          </div>

          <div>
            <p
              style="
                font-size: 16px;
                margin: 0;
                font-family: Poppins-Bold, sans-serif !important;
              "
            >
              Documentos Fiscais
            </p>

            <p
              style="
                font-size: 0.75rem;
                color: rgb(111, 111, 111);
                font-weight: 500 !important;
                margin: 0;
              "
            >
              Documentos emitidos para sua empresa
            </p>
          </div>
        </div>

        <div class="searchContainer">
          <SearchBar
            ref="searchBar"
            enableFilters
            enableDates
            textField="text"
            valueField="value"
            placeholder="Pesquisar por ..."
            :mask="filter.text"
            :isCpfCnpj="isCpfCnpj"
            :items="filterOptions"
            :inputSearchIsSelect="filter.type === 'status'"
            :itemsTypes="situationOptions"
            :clickIconSearch="listDfe"
            @changedFilter="clearFilterText"
            @selectFilterType="filter.type = $event"
            @selectTypes="filter.text = $event"
            @getInputvalue="filter.text = $event"
            @getInputStartDateValue="filter.startDate = $event"
            @getInputEndDateValue="filter.endDate = $event"
          />
        </div>
      </div>

      <div
        style="
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background-color: white;
          border: 1px solid #e3e0e0;
          border-radius: 7px;
        "
      >
        <div class="contentTable">
          <div style="flex-grow: 1; overflow: auto; height: 0">
            <table>
              <thead class="headTable">
                <tr>
                  <th style="border-radius: 7px 0 0 0">DATA EMISSÃO</th>
                  <th>EMITENTE</th>
                  <th>CNPJ EMITENTE</th>
                  <th>CHAVE DOCUMENTO</th>
                  <th>VALOR TOTAL</th>
                  <th style="border-radius: 0 7px 0 0"></th>
                </tr>
              </thead>

              <div class="spacer"></div>
              <tbody class="bodyTable" v-if="dfes.length">
                <tr v-for="dfe in dfes" :key="dfe.id">
                  <td>
                    <b-icon-check-circle-fill
                      v-if="dfe.synced"
                      style="color: green; margin-right: 0.2rem"
                      scale="1.3"
                    />
                    {{
                      dfe.dataEmissao
                        .split("T")[0]
                        .split("-")
                        .reverse()
                        .join("/")
                    }}
                  </td>
                  <td>
                    <p class="textEllipsis">
                      {{ dfe.nomeEmitente }}
                    </p>
                  </td>
                  <td>{{ dfe.cpfCnpjEmitente || "03.054.436/0001-51" }}</td>
                  <td>
                    <p class="textEllipsis">
                      {{ dfe.nfChave }}
                    </p>
                  </td>
                  <td>
                    {{
                      parseFloat(dfe.valorNf).toLocaleString("pt-br", {
                        style: "currency",
                        currency: "BRL",
                      })
                    }}
                  </td>
                  <td class="tdActions">
                    <div class="contentBtnActions" v-if="dfe.completed">
                      <button
                        v-b-tooltip.hover.top="'Gerar Compra'"
                        class="btnActions"
                        @click="openModalCfop(dfe.id)"
                      >
                        <b-icon-box scale="1.5" />
                      </button>

                      <button
                        v-b-tooltip.hover.top="'Realizar manifestação'"
                        class="btnActions"
                        @click="openModalManifest(dfe)"
                      >
                        <b-icon-arrow90deg-right scale="1.5" />
                      </button>

                      <button
                        :class="`${
                          loadingToDownload.id === dfe.id &&
                          loadingToDownload.isLoading &&
                          'blockRemove'
                        }`"
                        v-b-tooltip.hover.top="'Download XML'"
                        class="btnActions"
                        @click="downloadXml(dfe.id, dfe.url)"
                      >
                        <b-spinner
                          v-if="
                            loadingToDownload.id === dfe.id &&
                            loadingToDownload.isLoading
                          "
                          class="spin"
                        ></b-spinner>
                        <b-icon-file-earmark-arrow-down
                          scale="1.5"
                          :style="`${
                            loadingToDownload.id === dfe.id &&
                            loadingToDownload.isLoading &&
                            'color: rgb(115 112 112);'
                          }`"
                        />
                      </button>

                      <button
                        :class="`${
                          loadingToViewDanfe.id === dfe.id &&
                          loadingToViewDanfe.isLoading &&
                          'blockRemove'
                        }`"
                        v-b-tooltip.hover.top="'Ver DANFE'"
                        class="btnActions"
                        @click="generateDanfe(dfe.id)"
                      >
                        <b-spinner
                          v-if="
                            loadingToViewDanfe.id === dfe.id &&
                            loadingToViewDanfe.isLoading
                          "
                          class="spin"
                        ></b-spinner>
                        <b-icon-eye
                          scale="1.5"
                          :style="`${
                            loadingToViewDanfe.id === dfe.id &&
                            loadingToViewDanfe.isLoading &&
                            'color: rgb(115 112 112);'
                          }`"
                        />
                      </button>
                    </div>

                    <div class="contentBtnActions" v-else>
                      <button
                        class="btnActions"
                        style="
                          width: 84.6px;
                          display: flex;
                          justify-content: center;
                          align-items: center;
                          background-color: #e6e71687;
                          cursor: default;
                          color: #545454;
                        "
                      >
                        <p style="white-space: nowrap; margin: 0">
                          Aguardando...
                        </p>
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>

              <tbody class="bodyTable" v-else style="height: '100%">
                <tr style="height: '100%">
                  <td colspan="6" style="height: 100%">
                    Nenhum documento encontrado...
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="setBtn">
            <button
              class="itemBtn"
              @click="previousPage"
              v-if="filter.page > 1"
            >
              <b-icon-chevron-left></b-icon-chevron-left>
            </button>
            <button class="centerItemBtn">{{ filter.page }}</button>
            <button class="itemBtn" @click="nextPage" v-if="dfes.length">
              <b-icon-chevron-right></b-icon-chevron-right>
            </button>
          </div>
        </div>
      </div>

      <b-modal id="modalCFOP" hide-footer hide-header size="lg">
        <div class="title">
          <span>Selecione um CFOP</span>
        </div>

        <button class="closeModal" @click="$bvModal.hide('modalCFOP')">
          <b-icon-x scale="1.3" />
        </button>

        <div style="display: flex; gap: 1rem">
          <div>
            <div class="selectPlus">
              <label class="fixedSelect"
                >CFOP <span style="color: rgb(115, 0, 0)">*</span></label
              >
              <b-form-select
                class="borderInput shadow-none"
                :options="cfop"
                v-model="cfopSelected"
                size="sm"
              >
              </b-form-select>
            </div>
          </div>

          <div>
            <b-button class="btnsSave" @click="confirmCfop"
              >Confirmar
              <b-icon-check2-circle class="ml-1"></b-icon-check2-circle
            ></b-button>
          </div>
        </div>
      </b-modal>

      <b-modal
        id="modalManifest"
        hide-footer
        hide-header
        size="md"
        @hidden="clearDfe"
      >
        <div class="title">
          <span>Manifestação do Destinatário</span>
        </div>

        <button class="closeModal" @click="closeModalManifest">
          <b-icon-x scale="1.3" />
        </button>

        <div style="display: flex; flex-direction: column; gap: 1rem">
          <div
            v-if="dfeToManifest && dfeToManifest.events.length"
            style="margin-bottom: 10px"
          >
            <p style="margin: 0; font-size: 13px">Eventos já realizados</p>

            <div
              style="
                display: flex;
                align-items: center;
                gap: 0.3rem;
                margin-top: 0.3rem;
                margin-left: 0.5rem;
              "
            >
              <div
                style="
                  width: 8px;
                  height: 8px;
                  background-color: black;
                  border-radius: 50%;
                "
              ></div>

              <p
                v-for="(event, idx) in dfeToManifest.events"
                :key="idx"
                style="margin: 0; font-size: 10px; line-height: 1"
              >
                {{ handleShowTextEvent(event.tpEvento, event.xEvento) }}
              </p>
            </div>
          </div>

          <div :style="`${handleMargin && 'margin-top: 1rem'}`">
            <div class="selectPlus">
              <label class="fixedSelect"
                >Tipo do Evento
                <span style="color: rgb(115, 0, 0)">*</span></label
              >
              <b-form-select
                style="font-size: 11px"
                class="borderInput shadow-none"
                :options="manifestEvents"
                v-model="mainfestPayload.tipoEvento"
                size="sm"
              >
              </b-form-select>
            </div>
          </div>

          <div style="margin-top: 0.5rem">
            <div style="display: flex; gap: 4px; align-items: center">
              <p class="obsGeneral">Justificativa</p>

              <p class="observacoes">
                (Informe um motivo para o evento realizado)
              </p>
            </div>

            <textarea
              class="inputTextArea"
              rows="3"
              max-rows="6"
              v-model="mainfestPayload.justificativa"
            />
          </div>

          <div style="text-align: end">
            <b-button
              class="btnsSave"
              style="width: auto; position: relative"
              @click="sendManifest"
              :disabled="loadingToManifest"
            >
              Enviar
              <b-icon-check2-circle class="ml-1" />
              <b-spinner
                v-if="loadingToManifest"
                class="spin"
                style="right: 9px; top: 5px"
              />
            </b-button>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import SearchBar from "../UI/SearchBar/BarSearch.vue";
import ServiceDfe from "../../services/serviceDfe";
import { removeSpecialCharacters } from "../../utils/removeSpecialCharacters";
import { cfop } from "../../common/index";

export default {
  components: {
    SearchBar,
  },
  data() {
    return {
      dfes: [],
      filter: {
        text: "",
        type: "",
        isSynced: "",
        startDate: "",
        endDate: "",
        page: 1,
      },
      isCpfCnpj: false,
      cfop: cfop,
      dfeToManifest: null,
      manifestEvents: [
        { value: 210200, text: "Confirmação da operação" },
        // { value: 210210, text: "Ciência da operação" },
        { value: 210220, text: "Desconhecimento da operação" },
        { value: 210240, text: "Operação não realizada" },
      ],
      mainfestPayload: {
        chNFe: "",
        justificativa: "",
        tipoEvento: "",
      },
      cfopSelected: "",
      idNfeDfe: "",
      filterOptions: [
        { value: "", text: "Selecione uma opção" },
        { value: "status", text: "Status" },
        { value: "nomeEmitente", text: "Emitente" },
        { value: "cpfCnpjEmitente", text: "CPF/CNPJ Emitente" },
      ],
      situationOptions: [
        { value: "", text: "Selecione..." },
        { value: true, text: "Sincronizadas" },
        { value: "", text: "Não Sincronizadas" },
      ],
      loadingToManifest: false,
      tableLoading: false,
      loadingToDownload: {
        isLoading: false,
        id: null,
      },
      loadingToViewDanfe: {
        isLoading: false,
        id: null,
      },
    };
  },
  methods: {
    ...mapMutations(["SET_HTML_TO_PRINT"]),
    async listDfe() {
      try {
        this.tableLoading = true;
        const newType = this.handleSynced();

        const result = await ServiceDfe.listDfe(
          this.filter.isSynced,
          this.handleCpfCnpj(this.filter.text) || "",
          newType,
          this.filter.startDate,
          this.filter.endDate,
          this.filter.page
        );

        this.dfes = result || [];
      } finally {
        this.tableLoading = false;
      }
    },
    async getXmlString() {
      return await ServiceDfe.downloadStringXMl(this.idNfeDfe);
    },
    async confirmCfop() {
      if (!this.cfopSelected) {
        return this.$toast.open({
          message: "É necessário selecionar um CFOP para prosseguir",
          type: "info",
        });
      }

      const payload = {
        xml: await this.getXmlString(),
        cfop: this.cfopSelected,
        fromDfe: true,
      };

      this.$emit("payloadDfe", payload);
    },
    async downloadXml(id, url) {
      try {
        this.loadingToDownload = {
          isLoading: true,
          id: id,
        };
        const result = await ServiceDfe.urlToDownload([url]);

        if (result) {
          window.open(result[0]);
        }
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao baixar o XML",
          type: "info",
        });
      } finally {
        this.loadingToDownload = {
          isLoading: true,
          id: null,
        };
      }
    },
    async generateDanfe(id) {
      try {
        this.loadingToViewDanfe = {
          isLoading: true,
          id: id,
        };
        const result = await ServiceDfe.generateDanfe(id);

        if (result) {
          this.SET_HTML_TO_PRINT(result);
        }
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao abrir a DANFE",
          type: "info",
        });
      } finally {
        this.loadingToViewDanfe = {
          isLoading: false,
          id: null,
        };
      }
    },
    async sendManifest() {
      try {
        this.loadingToManifest = true;

        this.mainfestPayload = {
          ...this.mainfestPayload,
          chNFe: this.dfeToManifest.nfChave,
        };

        await ServiceDfe.manifestDfe([this.mainfestPayload]);

        this.closeModalManifest();
        this.listDfe();

        this.$toast.open({
          message: "Manifesto Realizado",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao realizar o manifesto",
          type: "info",
        });
      } finally {
        this.loadingToManifest = false;
      }
    },
    handleShowTextEvent(typeEvent, eventText) {
      const event = {
        210200: "Confirmação da operação",
        210210: "Ciência da operação",
        210220: "Desconhecimento da operação",
        210240: "Operação não realizada",
      };

      if (!typeEvent[event]) return eventText;

      return typeEvent[event];
    },
    closeModalManifest() {
      this.clearDfe();
      this.$bvModal.hide("modalManifest");
    },
    clearDfe() {
      this.mainfestPayload = {
        chNFe: "",
        justificativa: "",
        tipoEvento: "",
      };

      this.dfeToManifest = "";

      this.manifestEvents = [
        { value: 210200, text: "Confirmação da operação" },
        { value: 210220, text: "Desconhecimento da operação" },
        { value: 210240, text: "Operação não realizada" },
      ];
    },
    openModalCfop(idNfeDfe) {
      this.idNfeDfe = idNfeDfe;
      this.$bvModal.show("modalCFOP");
    },
    openModalManifest(nfe) {
      this.dfeToManifest = nfe;

      this.manifestEvents = this.manifestEvents.filter((item) => {
        const exist = this.dfeToManifest.events.find(
          (e) => String(e.tpEvento) === String(item.value)
        );

        if (!exist) return item;
      });

      this.$bvModal.show("modalManifest");
    },
    previousPage() {
      this.filter.page -= 1;
      this.listDfe();
    },
    nextPage() {
      this.filter.page += 1;
      this.listDfe();
    },

    clearFilterText() {
      if (this.filter.type.includes("cpfCnpj")) {
        this.isCpfCnpj = true;
      } else {
        this.isCpfCnpj = false;
      }
    },
    handleCpfCnpj(value) {
      if (
        this.filter.type === "cpfCnpjEmitente" ||
        this.filter.type === "cpfCnpjDestinatario"
      ) {
        return removeSpecialCharacters(value);
      }

      return value;
    },
    handleSynced() {
      if (this.filter.type === "status") {
        this.filter.isSynced = this.filter.text;
        return "";
      }

      return this.filter.type;
    },
  },
  computed: {
    handleMargin() {
      if (this.dfeToManifest?.events?.length) return false;

      return true;
    },
  },
  mounted() {
    this.listDfe();
  },
  beforeDestroy() {
    this.loadingToDownload = {
      isLoading: false,
      id: null,
    };

    this.loadingToViewDanfe = {
      isLoading: false,
      id: null,
    };
  },
};
</script>

<style scoped>
.container-dfe {
  width: 100%;
  height: 100vh;
  background-color: #f4f4f4;
  padding: 1rem 2rem 2rem 2rem;
}

.dfe {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
  height: 100%;
  font-size: 12px;
}

.header-card {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  border: 1px solid #e3e0e0;
  border-radius: 7px;
  padding: 1rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.header-title-block {
  display: flex;
  align-items: center;
  gap: 1rem;
  flex: 1 1 210px;
  min-width: 210px;
}

.searchContainer {
  flex: 2 1 450px;
  width: 100%;
}

.contentIconHeader {
  width: 35px;
  height: 35px;
  min-width: 35px;
  min-height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #0062562a !important;
  border-radius: 8px;
}

.contentTable {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  max-width: 100%;
}

.spacer {
  height: 0.3rem;
}

.spin {
  height: 20px;
  width: 20px;
  color: #a5a5a5;
  position: absolute;
  z-index: 200;
}

.selectPlus {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.fixedSelect {
  position: absolute;
  font-size: 10px;
  bottom: 15px;
  left: 10px;
  background-color: #ffffff;
  padding: 0 0.4em;
}

.borderInput {
  font-size: 14px;
  height: 30px;
  border: 1px solid #d5d3d3;
  border-radius: 5px;
  outline: none;
  transition: ease-in 0.1s all;
  padding-left: 5px;
  padding-right: 4px;
  color: #5c5855;
}

.contentBtnActions {
  display: flex;
  gap: 0.3rem;
  justify-content: flex-end;
  align-items: center;
}

.title {
  font-size: 16px;
  color: rgb(95, 95, 95);
  margin-bottom: 8px;
  border-bottom: 1px solid rgb(230, 230, 230);
  font-weight: 600;
}

.obsGeneral {
  font-size: 12px;
  color: black;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 500;
  margin: 0;
}

.observacoes {
  font-size: 10px;
  color: #ababab;
  font-style: italic;
  font-weight: 500;
  margin: 0;
}

.inputTextArea {
  width: 100%;
  border: none;
  outline: none;
  text-decoration: none;
  background-color: white;
  color: #5c5855;
  border-radius: 5px;
  height: 60px;
  padding-left: 5px;
  border: solid 1px #d9d9d9;
  resize: none;
  font-size: 11px;
}

.tdActions {
  padding-right: 1rem;
}

.blockRemove {
  background-color: #a1a1a12f;
  pointer-events: none !important;
  cursor: default !important;
}

.textEllipsis {
  white-space: nowrap !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  margin: 0;
  width: 100%;
}

.btnActions {
  position: relative;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 0;
  outline: none;
  border: none;
  border-radius: 3px;
  background-color: white;
  color: black;
  font-size: 10px;
  box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.186);
  transition: ease-in all 0.1s;
  font-weight: 600;
}

.btnActions:hover {
  background-color: #a1a1a12f;
  transition: ease-in all 0.1s;
}

.btnDropdown ul li {
  font-size: 12px !important;
}

.btnDropdown:hover {
  background-color: rgba(71, 206, 244, 0.396);
  transition: ease-in all 0.1s;
}

table {
  width: 100%;
  border-collapse: collapse;
}

table th {
  font-weight: normal;
}

table th:nth-child(1) {
  -webkit-border-radius: 3px 0px 0px 3px;
  border-radius: 3px 0px 0px 3px;
}

table th:nth-last-child(1) {
  -webkit-border-radius: 0px 3px 3px 0px;
  -moz-border-radius: 0px 3px 3px 0px;
  border-radius: 0px 3px 3px 0px;
}

table tr:not(:last-child):hover {
  background-color: #a1a1a113;
  border-radius: 3px;
  transition: ease-in all 0.1s;
}

tr {
  height: 45px;
  transition: ease-in all 0.1s;
}

.headTable {
  color: black;
  border-bottom: solid 1px #a1a1a12f;
  text-align: center;
  border-radius: 10px;
  background-color: #f9f9f9;
}

.bodyTable {
  text-align: center;
}

.bodyTable tr:not(:last-child) {
  border-bottom: solid 1px #a1a1a145;
}

.tdFooterPaginate {
  text-align: end;
  padding-right: 1rem;
  padding-top: 10px;
}

.tdFooterTotalRegisters {
  text-align: start;
  padding-right: 1rem;
  padding-top: 10px;
}

.tdFooterTotalRegisters p {
  margin: 0;
}

.setBtn {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 0.5rem 1rem;
  border-top: solid 1px #a1a1a12f;
}

.itemBtn {
  display: flex;
  text-align: center;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  font-weight: bold;
  border: 1px solid rgb(175, 174, 174);
  border-radius: 50%;
  color: #3a4750;
  transition: ease-in all 0.1s;
}

.itemBtn:hover {
  background: #3a4750;
  transition: ease-in all 0.1s;
  color: whitesmoke;
}

.itemBtn:disabled {
  opacity: 0;
}

.centerItemBtn {
  display: flex;
  text-align: center;
  align-content: center;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  font-weight: bold;
  border: 1px solid rgb(175, 174, 174);
  border-radius: 50%;
  color: #1b3159;
  cursor: auto;
}

.closeModal {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 1000;
  color: rgb(255, 153, 153);
  cursor: pointer;
  border: 1px solid rgb(238, 238, 238);
  padding: 2px 3px;
  border-radius: 4px;
}

.closeModal:hover {
  color: red;
  background: rgba(245, 245, 245, 0.764);
}

.btnsSave {
  border-radius: 5px;
  background-color: #00395d;
  width: 165px;
  border: none;
  color: white;
  font-size: 12px;
  font-weight: 500;
}

@media screen and (max-width: 1200px) and (min-width: 768px) {
  .searchContainer {
    padding-top: 0;
  }
}

@media screen and (max-width: 700px) {
  .searchContainer {
    padding: 0 0 1rem 0;
  }
}

@media screen and (max-width: 700px) {
  .dfe {
    display: flex;
    margin-left: 10px;
    width: 100%;
    height: 100vh;
    font-size: 12px;
    flex-direction: column;
  }
}
</style>